exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".breadcrumb {\n    padding: 0px 12px 1px;\n    border-radius: 4px;\n    background-color: #ffffff;\n    background-size: cover;\n    /* Home */\n    font-family: 'Open Sans';\n    font-size: 12px;\n    margin-bottom: 0;\n    width: -moz-fit-content;\n    width: fit-content;\n}\n\n.breadcrumb>li>a {\n    color: #8e8fa6;\n}\n\n.breadcrumb>li:last-child>a {\n    color: #26273b;\n}\n\na {\n    text-decoration: none;\n}\n\n.breadcrumb>li>a:hover {\n    color: #26273b;\n}\n\n.breadcrumb>li+li:before {\n    content: \">\" !important;\n    color: #26273b;\n    padding: 0 3;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/breadcrumbs/breadcrumbs.component.css
// module id = 825
// module chunks = 0